<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("linemente.title") }}</h1>
    <b-tabs content-class="mt-3">
      <!-- 検索欄 -->
      <b-tab :title="this.$i18n.t('linemente.tab_search')" active>
        <b-card class="w-50 mb-3">
          <form>
            <b-form-group
              id="lineIdSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('linemente.label_line_id')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="lineIdSearch" :placeholder="this.$i18n.t('linemente.placeholder_line_id')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="lineNameSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('linemente.label_line_name')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="lineNameSearch" :placeholder="this.$i18n.t('linemente.placeholder_line_name')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="baseListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('linemente.label_base')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="baseListSearch" :options="baseSearchOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="lineKindListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('linemente.label_line_kind')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="lineKindListSearch" :options="lineKindSearchOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <div>
              <!-- 検索ボタン -->
              <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("linemente.button_search") }}</b-button>
            </div>
          </form>
        </b-card>
        <b-card v-if="isSearch">
        <b-row class="d-flex align-items-center">
          <b-col sm="2" md="2" class="my-1">
            <!-- アクション -->
            <b-dropdown right variant="primary" :text=lblAction>
              <b-dropdown-item @click="valid" >{{ $i18n.t("linemente.button_valid") }}</b-dropdown-item>
              <b-dropdown-item @click="invalid" >{{ $i18n.t("linemente.button_invalid") }}</b-dropdown-item>
            </b-dropdown>
          </b-col>
          <b-col sm="2" md="2" class="my-1">
            <div>{{ $i18n.t("linemente.label_num_of_disp") }}
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
                style="width: auto"
              ></b-form-select>
            </div>
          </b-col>
          <b-col sm="8" md="8" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
          </b-col>
        </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :per-page="perPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="items"
            :fields="fields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :tbody-tr-class="rowClass"
          >
            <template v-slot:head(action)="row">
              <b-form inline>
                <b-form-checkbox size="lg" :checked="isAllSelected" v-on:change="selectAll" name="check-button"></b-form-checkbox>
              </b-form>
            </template>
            <template v-slot:cell(action)="row">
              <b-form-checkbox size="lg" v-model="row.item.selectedFlg" v-on:change="selectOne(row.item.index)"  name="check-button"></b-form-checkbox>
            </template>
            <template v-slot:cell(edit)="row">
              <!-- 編集ボタン -->
              <b-button v-if="row.item.efFlg === '1'" size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("linemente.button_edit") }}</b-button>
              <b-button v-if="row.item.efFlg === '0'" disabled=true size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("linemente.button_edit") }}</b-button>
            </template>
          </b-table>
        </b-card>
      </b-tab>
      <!-- 新規登録 -->
      <b-tab :title="this.$i18n.t('linemente.tab_register')">
        <b-card class="w-50">
          <form>
            <b-form-group
              id="lineIdForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('linemente.label_line_id_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="lineIdForm" :placeholder="this.$i18n.t('linemente.placeholder_line_id')" maxlength="4"></b-form-input>
            </b-form-group>
            <b-form-group
              id="lineNameForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('linemente.label_line_name_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="lineNameForm" :placeholder="this.$i18n.t('linemente.placeholder_line_name')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="baseListForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('linemente.label_base_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="baseListForm" :options="baseOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="lineKindListForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('linemente.label_line_kind_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="lineKindListForm" :options="lineKindOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("linemente.button_register") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
      <!-- 表示順変更 -->
      <b-tab :title="this.$i18n.t('linemente.tab_disp_order')" @click="createdDispNumChange">
        <b-card class="w-50">
          <form>
            <b-form-group
              id="dispNumList"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('linemente.label_disp_order')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="lineSelected" :options="dispNumOptions" :select-size="10" ></b-form-select>
              <b-button variant="secondary" class="float-right px-5" @click="downDisp">↓{{ $i18n.t("linemente.button_down") }}</b-button>
              <b-button variant="secondary" class="float-right px-5" @click="upDisp">↑{{ $i18n.t("linemente.button_up") }}</b-button>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist2" class="float-right px-5">{{ $i18n.t("linemente.button_change_order") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
    </b-tabs>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('linemente.info_register')" :titleMsg="this.$i18n.t('linemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirm-modal modId="md-confirm2" :msg="this.$i18n.t('linemente.info_disp_order')" :titleMsg="this.$i18n.t('linemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm2"/>
    <confirm-modal modId="md-confirm3" :msg="this.$i18n.t('linemente.info_valid')" :titleMsg="this.$i18n.t('linemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="validConfirm"/>
    <confirm-modal modId="md-confirm4" :msg="this.$i18n.t('linemente.info_invalid')" :titleMsg="this.$i18n.t('linemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="invalidConfirm"/>
    <confirmModal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      fields: [
        { key: 'action', label: '' },
        { key: 'lineId', label: this.$i18n.t('linemente.label_line_id'), sortable: true },
        { key: 'lineName', label: this.$i18n.t('linemente.label_line_name'), sortable: true },
        { key: 'baseName', label: this.$i18n.t('linemente.label_base'), sortable: true },
        { key: 'lineKindName', label: this.$i18n.t('linemente.label_line_kind'), sortable: true },
        { key: 'uOp', label: this.$i18n.t('linemente.label_register_user'), sortable: true },
        { key: 'uDate', label: this.$i18n.t('linemente.label_register_date'), sortable: true },
        { key: 'efFlgStr', label: this.$i18n.t('linemente.label_ef_flg'), sortable: true },
        { key: 'edit', label: this.$i18n.t('usermente.button_edit') }
      ],
      items: [],
      baseListSearch: '',
      lineKindListSearch: '',
      baseListForm: '',
      lineKindListForm: '',
      baseSearchOptions: [{ value: '', text: this.$i18n.t('linemente.label_all_base') }],
      lineKindSearchOptions: [{ value: '', text: this.$i18n.t('linemente.label_all_line_kind') }],
      dispNumOptions: [],
      baseOptions: [{ value: '', text: this.$i18n.t('linemente.label_select') }],
      lineKindOptions: [{ value: '', text: this.$i18n.t('linemente.label_select') }],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      isAllSelected: false,
      selectedItems: [],
      lblAction: this.$i18n.t('linemente.button_action'),
      lineIdForm: null,
      lineNameForm: null,
      passwordForm: null,
      passwordCheckForm: null,
      lineSelected: null,
      errMsg: null,
      errSbj: null
    }
  },
  created () {
    this.searchBase()
    this.searchLineKind()

    // 更新画面から戻った場合は再検索
    var searchFlg = this.$route.query.searchFlg
    if (searchFlg !== undefined) {
      if (searchFlg[0] === 1) {
        // 配列として渡されてしまうため先頭の値のみ取得
        var tmp = this.$route.query.searchLineId
        this.lineIdSearch = tmp[0]
        tmp = this.$route.query.searchLineName
        this.lineNameSearch = tmp[0]
        tmp = this.$route.query.searchBaseId
        this.baseListSearch = tmp[0]
        tmp = this.$route.query.searchLineKindId
        this.lineKindListSearch = tmp[0]
        this.search()
      }
    }
  },
  methods: {
    search: function () {
      // リクエスト
      var reqObj = {}
      var lineIdStr = this.lineIdSearch
      if (lineIdStr == null) {
        lineIdStr = ''
      }
      var lineNameStr = this.lineNameSearch
      if (lineNameStr == null) {
        lineNameStr = ''
      }
      var baseIdStr = this.baseListSearch
      if (baseIdStr == null) {
        baseIdStr = ''
      } else {
        baseIdStr = String(baseIdStr)
      }
      var LindKindIdStr = this.lineKindListSearch
      if (LindKindIdStr == null) {
        LindKindIdStr = ''
      } else {
        LindKindIdStr = String(LindKindIdStr)
      }

      reqObj.lineId = lineIdStr
      reqObj.lineIdLikeFlg = '1'
      reqObj.lineName = lineNameStr
      reqObj.base = baseIdStr
      reqObj.lineKind = LindKindIdStr
      reqObj.efFlg = ''

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/line/select', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var lineList = res.data.lineInfo
            var lines = []
            if (lineList.length === 0) {
              this.errSbj = this.$i18n.t('linemente.title')
              this.errMsg = this.$i18n.t('linemente.err_not_data')
              this.$bvModal.show('md-err')
              this.isSearch = false
              return
            }

            // 整形
            for (var i = 0; i < lineList.length; i++) {
              var line = {}
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(lineList[i].u_date, 'YYYY-MM-DD HH:mm:ss')
              var output = null
              if (String(utc) === 'Invalid date') {
                output = ''
              } else {
                // local時刻に変換＆フォーマット
                output = utc.local().format('YYYY-MM-DD HH:mm:ss')
              }
              line.lineId = lineList[i].line_id
              line.lineName = lineList[i].line_name
              line.baseId = lineList[i].base_id
              line.baseName = lineList[i].base_name
              line.lineKindId = lineList[i].line_kind_id
              line.lineKindName = lineList[i].line_kind_name
              line.uOp = lineList[i].u_op_name
              line.uDate = output
              // TODO json
              line.edit = this.$i18n.t('linemente.label_edit')
              line.efFlg = lineList[i].ef_flg
              if (lineList[i].ef_flg === '1') {
                // TODO json
                line.efFlgStr = this.$i18n.t('linemente.label_valid')
              } else {
                // TODO json
                line.efFlgStr = this.$i18n.t('linemente.label_invalid')
                line.status = 'awesome'
              }
              line.selectedFlg = false
              // 選択状態書き換え時に使用するindex
              line.index = i
              lines.push(line)
            }
            // ページング設定
            this.totalRows = lines.length
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.items.splice(0, 0, ...lines)
            // 検索結果表示
            this.isSearch = true
            // 全選択チェック
            this.isAllSelected = false
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist: function () {
      // 入力値チェック
      if (this.lineIdForm === null || this.lineIdForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_line_id_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkNum(this.lineIdForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_line_id_number')
        this.$bvModal.show('md-err')
        return
      }
      if (this.lineNameForm === null || this.lineNameForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_line_name_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.lineNameForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_line_name_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (this.baseListForm === undefined) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_base_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (this.lineKindListForm === undefined) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_line_kind_hissu')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.lineId = this.lineIdForm
      reqObj.lineName = this.lineNameForm
      reqObj.base = this.baseListForm
      reqObj.lineKind = this.lineKindListForm

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/line/register', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist2: function () {
      // 表示順変更
      var lineId = []
      for (var i = 0; i < this.dispNumOptions.length; i++) {
        lineId.push(String(this.dispNumOptions[i].value))
      }
      var body = {}
      body.lineId = lineId

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/line/updateDispOrder', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm2')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: function () {
      this.lineIdForm = null
      this.lineNameForm = null
      this.baseListForm = null
      this.lineKindListForm = null
      this.$bvModal.hide('md-confirm')
    },
    registConfirm2: function () {
      this.$bvModal.hide('md-confirm2')
    },
    valid: function () {
      this.selectedItems.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          this.selectedItems.push(String(this.items[i].lineId))
        }
      }

      if (this.selectedItems.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.mode = '1'
      reqObj.lineId = this.selectedItems

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/line/updateEfFlg', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.search()
            this.$bvModal.show('md-confirm3')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    invalid: function () {
      this.selectedItems.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          this.selectedItems.push(String(this.items[i].lineId))
        }
      }

      if (this.selectedItems.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.mode = '0'
      reqObj.lineId = this.selectedItems

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/line/updateEfFlg', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.search()
            this.$bvModal.show('md-confirm4')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    // 拠点取得
    searchBase: function () {
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true

      this.$axios
        .post(window.END_POINT + '/master/base/select', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var baseList = res.data.base
            var bases = []

            // 整形
            for (var i = 0; i < baseList.length; i++) {
              var base = {}
              base.value = baseList[i].base_id
              base.text = baseList[i].base_name
              bases.push(base)
            }
            // 一旦データクリア
            this.baseOptions.splice(1)
            this.baseSearchOptions.splice(1)
            // データセット
            this.baseOptions.splice(1, 0, ...bases)
            this.baseSearchOptions.splice(1, 0, ...bases)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    // ライン種別取得
    searchLineKind: function () {
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/lineKind/select', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var lineKindList = res.data.lineKind
            var lineKinds = []

            // 整形
            for (var i = 0; i < lineKindList.length; i++) {
              var lineKind = {}
              lineKind.value = lineKindList[i].line_kind_id
              lineKind.text = lineKindList[i].line_kind_name
              lineKinds.push(lineKind)
            }
            // 一旦データクリア
            this.lineKindOptions.splice(1)
            this.lineKindSearchOptions.splice(1)
            // データセット
            this.lineKindOptions.splice(1, 0, ...lineKinds)
            this.lineKindSearchOptions.splice(1, 0, ...lineKinds)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    validConfirm: function () {
      this.$bvModal.hide('md-confirm3')
    },
    invalidConfirm: function () {
      this.$bvModal.hide('md-confirm4')
    },
    edit: function (item, index, button) {
      // 検索結果保持(戻るボタン対応)
      var lineIdStr = this.lineIdSearch
      if (lineIdStr == null) {
        lineIdStr = ''
      }
      var lineNameStr = this.lineNameSearch
      if (lineNameStr == null) {
        lineNameStr = ''
      }
      var baseIdStr = this.baseListSearch
      if (baseIdStr == null) {
        baseIdStr = ''
      } else {
        baseIdStr = String(baseIdStr)
      }
      var LindKindIdStr = this.lineKindListSearch
      if (LindKindIdStr == null) {
        LindKindIdStr = ''
      } else {
        LindKindIdStr = String(LindKindIdStr)
      }
      this.$store.store.state.searchLineId = lineIdStr
      this.$store.store.state.searchLineName = lineNameStr
      this.$store.store.state.searchBaseId = baseIdStr
      this.$store.store.state.searchLineKindId = LindKindIdStr

      // 編集データ
      this.$store.store.state.lineId = item.lineId
      this.$store.store.state.lineName = item.lineName
      this.$store.store.state.baseId = item.baseId
      this.$store.store.state.lineKindId = item.lineKindId
      this.$router.push({ path: 'linementeEdit' })
    },
    rowClass: function (item, type) {
      if (!item) return
      if (item.status === 'awesome') return 'table-danger'
    },
    selectAll () {
      if (this.isAllSelected) {
        this.isAllSelected = false
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].selectedFlg = false
        }
      } else {
        this.isAllSelected = true
        for (var j = 0; j < this.items.length; j++) {
          this.items[j].selectedFlg = true
        }
      }
    },
    selectOne (index) {
      this.items[index].selectedFlg = !this.items[index].selectedFlg
      var selectedCnt = 0
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          selectedCnt++
        }
      }
      if (selectedCnt !== this.items.length) {
        this.isAllSelected = false
      } else {
        this.isAllSelected = true
      }
    },
    createdDispNumChange () {
      var body = {}

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/line/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            // 表示順整形
            var lineInfoList = res.data.lineInfo
            var dispNumOptions = []
            for (var i = 0; i < lineInfoList.length; i++) {
              var dispNumOption = {}
              dispNumOption.value = lineInfoList[i].line_id
              dispNumOption.text = lineInfoList[i].line_name
              dispNumOptions.push(dispNumOption)
            }
            this.dispNumOptions.splice(0)
            this.dispNumOptions.splice(0, 0, ...dispNumOptions)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    downDisp: function () {
      if (this.lineSelected === null) {
        return
      }
      // iで表示順を取得
      for (var i = 0; i < this.dispNumOptions.length; i++) {
        if (this.lineSelected === this.dispNumOptions[i].value) {
          break
        }
      }
      // 順序を入れ替え
      var selectedLineInfo = this.dispNumOptions[i]
      if (i !== (this.dispNumOptions.length - 1)) {
        var exchangeLineInfo = this.dispNumOptions[i + 1]
        this.dispNumOptions.splice(i, 1, exchangeLineInfo)
        this.dispNumOptions.splice(i + 1, 1, selectedLineInfo)
      }
    },
    upDisp: function () {
      if (this.lineSelected === null) {
        return
      }
      // iで表示順を取得
      for (var i = 0; i < this.dispNumOptions.length; i++) {
        if (this.lineSelected === this.dispNumOptions[i].value) {
          break
        }
      }
      // 順序を入れ替え
      var selectedLineInfo = this.dispNumOptions[i]
      if (i !== 0) {
        var exchangeLineInfo = this.dispNumOptions[i - 1]
        this.dispNumOptions.splice(i, 1, exchangeLineInfo)
        this.dispNumOptions.splice(i - 1, 1, selectedLineInfo)
      }
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Linemente.vue